<template>
    <checker-detail-row>
        <div slot="left">
            <long-term-booking-total-label/>
        </div>
        <div slot="right">
            <strong v-if="bookingValueWithServiceFee" class="text-green">
                <span>&pound;{{ bookingValueWithServiceFee | currencyFormat }}</span>
            </strong>
            <strong v-else class="text-green">
                &pound;{{ space.price_matrix.monthly | currencyFormat }}
            </strong>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import LongTermBookingTotalLabel from '../../LongTermBookingTotalLabel';
    import { mapGetters } from 'vuex';

    export default {
        name: 'amount-due-row',

        components: { LongTermBookingTotalLabel, CheckerDetailRow },

        props: {
            space: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...mapGetters('booking', [
                'quoteValue',
                'bookingValueWithServiceFee',
                'seasonIntervalData',
            ]),
        },
    };
</script>
